module.exports = __webpack_public_path__ + "static/media/EN_copy.87cca9bb.png";